import { useStringUtils } from '~/commons/stringsUtil'
import { validate as isValidUUID } from 'uuid'
import router from '~/router'
import { computed } from '@vue/composition-api'
const route = computed(() => router.app.$route.fullPath)

const { trim } = useStringUtils()
const state = {
  filters: new Map()
}

const getters = {
  getFilter: state => (key) => {
    return (state.filters.get(route.value) || {})[key] || null
  },
  filters: state => () => {
    return state.filters.get(route.value) || {}
  },
  hasFilters: state => () => {
    const filters = state.filters.get(route.value) || {}
    const keys = Object.keys(filters)
    if (keys.length === 0) return false
    // check if it has more than one filter with no null values (parent_id is ignored as it's set automatically)
    return keys.filter(key => key !== 'parent_id' && filters[key] !== null).length > 0
  },
  numberOfFilters: state => () => {
    const filters = state.filters.get(route.value) || {}
    const keys = Object.keys(filters)
    if (keys.length === 0) return 0
    return keys.filter(key => key !== 'parent_id' && filters[key] !== null).length
  },
  isEmpty: (state, getters) => {
    return !getters.hasFilters()
  }
}

const mutations = {
  clearAllFilters (state) {
    state.filters = new Map()
  },
  clearFilters (state) {
    state.filters.set(route.value, {})
  },
  clearRouteFilters (state, route) {
    state.filters.set(route, {})
  },
  setFilter (state, filter = {}) {
    if (!filter || !filter.key) {
      return
    }
    state.filters.set(route.value, {
      ...(state.filters.get(route.value) || {}),
      [filter.key]: filter.value
    })
  }
}

const actions = {
  clearFilters ({commit}) {
    commit('clearFilters')
  },
  clearRouteFilters ({commit}, route) {
    commit('clearRouteFilters', route)
  },
  setFilter ({commit}, filter) {
    if (filter === null) {
      commit('clearFilters')
      return
    }
    commit('setFilter', filter)
  },
  setParentIDFromPath ({commit}, path = '') {
    if (path === '' || typeof path !== 'string') {
      return
    }
    path = trim(path, '/')
    let id = path.split('/').pop()
    switch (true) {
      case id === 'trash' || id === 'shared' || id === 'recents' ||
      id === 'favorites' || id === 'mysearch':
        return
      case id === 'myspace':
        break
      case !isNaN(id):
        id = 'oldFileId:' + id
        break
      case isValidUUID(id):
        break
      default:
        // TODO review if filters are allowed at fileFilter views
        id = null
    }
    commit('setFilter', { key: 'parent_id', value: id })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/files/filters.js